import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { AuthorizationError, RouteErrorHandler } from '@/shared/components/route-error-handler';
import { createRoute } from '@tanstack/react-router';

export const adminRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'admin',
  wrapInSuspense: true,
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new AuthorizationError('User is not an admin');
    }
  },
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="admin" />;
  },
});
